import { Injectable } from '@angular/core';
import { Logger } from '@services/logging/logger';
import { buildEngageUrlForClassicUrl } from './classic-to-engage-page-map';

export enum EngageHistoryMode {
    Push = 'push',
    Replace = 'replace',
}

@Injectable({ providedIn: 'root' })
export class EngageRedirectService {

    public redirectToEngage(classicUrl: string, tenantId: string, logContext: string, historyMode = EngageHistoryMode.Push): boolean {
        const engageUrl = buildEngageUrlForClassicUrl(classicUrl, tenantId);
        if (!engageUrl) {
            Logger.warn(`${logContext}: no Engage counterpart for "${classicUrl}", staying put`);
            return false;
        }

        if (historyMode === EngageHistoryMode.Replace) {
            window.location.replace(engageUrl);
            return true;
        }

        window.location.assign(engageUrl);
        return true;
    }
}
